import { useContext, useState } from 'react';
import {
  makeStyles,
  tokens,
  Tree,
  TreeItem,
  TreeItemLayout,
  TreeItemValue,
  TreeOpenChangeData,
  TreeOpenChangeEvent,
} from '@fluentui/react-components';

import { TTreeHeading } from '../../tiptap/nodes/heading/HeadingNode';
import DocumentContext from '../../contexts/DocumentContext.context';
import useScrollContent from '@modules/documents/hooks/useScrollContent.hook';
import { SignInContext } from '../../../users';

const useStyles = makeStyles({
  root: {
    marginLeft: tokens.spacingHorizontalS,
    marginRight: tokens.spacingHorizontalS,

    '& .fui-TreeItemLayout__main': {
      width: '100%',
      minHeight: 'inherit',
    },
  },
});

// refContentNode is outdated and is no longer needed here
const buildTree = (headings: TTreeHeading[], handleScroll: (id: string) => void, opts?: { isH5RefEnabled?: boolean }) =>
  headings.map((heading) => {
    const isBranch = heading.children.length > 0;
    const isH5Ref = heading.level === 5 && opts?.isH5RefEnabled;

    return (
      <TreeItem key={heading.id} itemType={isBranch ? 'branch' : 'leaf'} value={heading.id}>
        <TreeItemLayout>
          <button
            type="button"
            onClick={() => handleScroll(heading.id)}
            className="flex items-center w-full min-h-[inherit] text-left"
          >
            {!isH5Ref ? (
              <span className="w-full">
                {heading.numbering} {heading.text}
              </span>
            ) : (
              <span className="w-full">{heading.text}</span>
            )}
          </button>
        </TreeItemLayout>
        {isBranch && <Tree>{buildTree(heading.children, handleScroll, opts)}</Tree>}
      </TreeItem>
    );
  });

const NavHeadings = () => {
  const { treeHeadings: headings } = useContext(DocumentContext);
  const {
    organization: { mock },
  } = useContext(SignInContext);
  const [openItems, setOpenItems] = useState<Iterable<TreeItemValue>>([]);

  const scrollContent = useScrollContent();
  const handleScroll = (headingId: string) => {
    scrollContent({ value: headingId });
  };

  const onOpenChange = (_e: TreeOpenChangeEvent, data: TreeOpenChangeData) => {
    if (data.type === 'ExpandIconClick') setOpenItems(data.openItems);
  };

  const classes = useStyles();

  if (headings.length <= 0) return <p className="pl-5">No headings found.</p>;

  return (
    <Tree aria-label="Headings" openItems={openItems} onOpenChange={onOpenChange} className={classes.root}>
      {buildTree(headings, handleScroll, { isH5RefEnabled: mock.isH5RefEnabled })}
    </Tree>
  );
};

export default NavHeadings;
